import { makeStyles } from '@material-ui/core/styles'
import { DIRECTORY_RESULTS_MAX_WIDTH } from '@layouts/coaches-search/directory-results-layout'

export const useStyles = makeStyles((theme) => ({
  cardRoot: {
    height: '350px',
    marginTop: '50px',
    border: '1px solid #ccc',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    overflow: 'visible !important',
    cursor: 'pointer',
  },
  avatarWrapper: {
    width: '100%',
    height: '40px',
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
  },
  avatarStyles: {
    height: '100px',
    width: '100px',
    position: 'absolute',
    margin: '-50px 0 50px 0',
    textTransform: 'uppercase',
    fontSize: '2rem',
    border: '3px solid white',
    boxShadow: '0px 0px 1px 1px rgba(0, 0, 0, 0.15)',
    zIndex: '1',
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'hidden',
  },
  cardDetail: {
    paddingLeft: '1.75em',
  },
  cardDetailIcon: {
    position: 'absolute',
    top: '-0.15em',
  },
  cardActions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  cardDetailDivider: {
    position: 'absolute',
    top: '0',
  },
  cardActionsArrow: {
    padding: '0 10px',
    marginTop: '8px',
  },
  titleStyles: {
    color: '#AB9157',
    textTransform: 'uppercase',
    padding: '5px 0',
    margin: '15px 0',
    letterSpacing: '2px',
    fontWeight: '600',
  },
  adminButtons: {
    display: 'flex',
    justifyContent: 'space-around',
    width: '85%',
    borderTop: '1px solid darkGray',
  },
  actionButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '85%',
    height: '50px',
    borderTop: '1px solid darkGray',
    textTransform: 'uppercase',
  },
  moreResultsControlArea: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  resultsGrid: {
    width: '100%',
    maxWidth: DIRECTORY_RESULTS_MAX_WIDTH,
    marginLeft: 'auto',
    marginRight: 'auto',
    alignItems: 'stretch',
    justifyContent: 'center',
  },
  resultsGridItem: {
    display: 'flex',
    minWidth: 0,
    '& > *': {
      width: '100%',
      height: '100%',
    },
  },
  skeletonCard: {
    width: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 14,
    backgroundColor: theme.palette.common.white,
    border: '1px solid rgba(15, 34, 52, 0.06)',
    boxShadow: '0 8px 24px rgba(15, 34, 52, 0.06)',
  },
  skeletonPhoto: {
    width: '100%',
    aspectRatio: '1 / 1',
    '& > *': {
      height: '100%',
      transform: 'none',
    },
  },
  skeletonBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    padding: '12px 14px 14px',
  },
  skeletonTag: {
    marginTop: 8,
    borderRadius: 999,
    transform: 'none',
  },
  moreSearchResultsBtn: {
    margin: '1.5rem 0 1rem 0',
    minHeight: 48,
    height: 48,
    padding: theme.spacing(0.75, 2.5),
    borderRadius: 999,
    textTransform: 'none',
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: 1.2,
    color: '#00234B',
    backgroundColor: theme.palette.common.white,
    border: '1px solid #dfe3ea',
    boxShadow: 'none',
    textDecoration: 'none',
    cursor: 'pointer',
    '& .MuiButton-label': {
      display: 'flex',
      alignItems: 'center',
    },
    '& .MuiButton-startIcon': {
      marginRight: theme.spacing(0.75),
      marginLeft: 0,
      color: 'inherit',
    },
    '&:hover': {
      backgroundColor: theme.palette.blue.light25,
      borderColor: theme.palette.blue.main,
      color: theme.palette.blue.main,
      boxShadow: 'none',
      textDecoration: 'none',
    },
    '&.Mui-disabled': {
      color: '#c7ccd3',
      backgroundColor: theme.palette.common.white,
      borderColor: '#dfe3ea',
    },
  },
  moreSearchResultsControl: {
    margin: '2em',
    padding: '1.5em 5em',
    fontSize: '14px',
    fontWeight: 'bold',
    letterSpacing: '1.25px',
    textTransform: 'uppercase',
    color: theme.palette.secondary.main,
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.secondary.main}`,
    transition: 'background .25s cubic-bezier(0.4, 0, 0.2, 1), color 0.15s linear',
    '&:hover': {
      color: '#808080',
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
    },
  },
  iconWrapper: {
    display: 'flex',
    alignItems: 'flex-end',
    lineHeight: '22px',
    marginBottom: theme.spacing(1),
    marginLeft: '-6px',
    position: 'relative',
  },
  divider: {
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down(1200)]: {
      marginBottom: '0px',
    },
    [theme.breakpoints.only('xs')]: {
      display: 'none',
    },
  },
}))
